import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    state: {
        locationList: [],
        searchValue: "",
        selectFilter: []
    },
    district: {
        locationList: [],
        searchValue: "",
        selectFilter: []
    },
    city: {
        locationList: [],
        searchValue: "",
        selectFilter: []
    },
    searchDealerData: {
        searchDealerName: '',
        sortByStatus: '',
        sortKey: '',
        dateFilter: 'All',
        district: '',
        status: 'All',
    },
    page: 1,
};


const dealerSlice = createSlice({
    name: "dealer",
    initialState,
    reducers: {
        // -------- for State ----------
        setStateData: (state, action) => {
            state.state = { ...state.state, ...action.payload };
        },

        // -------- for District ----------
        setDistrictData: (state, action) => {
            state.district = { ...state.district, ...action.payload };
        },

        // -------- for City ----------
        setCityData: (state, action) => {
            state.city = { ...state.city, ...action.payload };
        },

        // -------- for Search Dealer ----------
        setSearchDealerData: (state, action) => {
            state.searchDealerData = { ...state.searchDealerData, ...action.payload };
        },
        setPage: (state, action) => {
            state.page = action.payload;
        },

        resetSearchDealerData: (state) => {
            state.searchDealerData = initialState.searchDealerData;
            state.state = initialState.state;
            state.district = initialState.district;
            state.city = initialState.city;
            state.page = initialState.page;
        }
    }
});

export const {
    setStateData,
    setDistrictData,
    setCityData,
    setSearchDealerData,
    setPage,
    resetSearchDealerData
} = dealerSlice.actions;

export default dealerSlice.reducer;
